<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <PmReportGnbDataLeft ref="pmReportGnbDataLeftTree" @reportGnbDataClickEventPush="reportGnbDataClickEventPush" ></PmReportGnbDataLeft>
    </template>
    <template v-slot:right_view>
      <PmReportGnbDataRightList ref="pmReportGnbDataRightList"></PmReportGnbDataRightList>
    </template>
  </BasicLayout>
</template>

<script>
  import BasicLayout from '../../../layouts/BasicLayout';
  import PmReportGnbDataLeft from "../../../components/pmConfig/gnb/PmReportGnbData/Left/PmReportGnbDataLeft";
  import PmReportGnbDataRightList from "../../../components/pmConfig/gnb/PmReportGnbData/Right/PmReportGnbDataRightList";
  export default {
    name: 'PmReportGnbData',
    components: {
      BasicLayout,
      PmReportGnbDataLeft,
      PmReportGnbDataRightList
    },
    data() {
      return {
        left: {
          show: true,
          name: this.$t('Pm.reportGnbData')
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.gnbManagement')}/${this.$t('Pm.reportGnbData')}`
        },
      }
    },
    methods: {
      reportGnbDataClickEventPush(params){
        this.$refs.pmReportGnbDataRightList.getDataByTaskId(params);
      }
    }
  };
</script>

<style scoped>
</style>
